import Api, { _getClient } from "./Api";
import { handleError } from "../util/ApiErrorUtil";

class Auth {
  static login(username, password, authBy) {

    return new Promise((resolve, reject) => {
      return Api.post(`/auth`, {
        username,
        password,
        authBy
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log("error", err);
          reject({
            message: handleError(err),
            status: err && err.response && err.response.status,
            response: err && err.response
          });
        });
    });
  }

  static refresh() {
    return new Promise((resolve, reject) => {
      return Api.get(`/auth/me`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject({
            message: handleError(err),
            status: err && err.response && err.response.status,
            response: err && err.response
          });
        });
    });
  }

  static validateExternalToken(token) {
    const client = _getClient({ token: `Bearer ${token}` });

    return new Promise((resolve, reject) => {
      return client
        .get(`/auth/me`)
        .then(res => resolve(res.data))
        .catch(err => reject({
          message: handleError(err),
          status: err && err.response && err.response.status,
          response: err && err.response
        }));
    });
  }
}
export default Auth;
